import styled, { createGlobalStyle } from 'styled-components'

export const StateDialogContent = styled.div`
  padding-top: 38px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const StateDialogText = styled.div`
  font-size: 16px;
  text-align: center;
  margin: 23px 6px 49px;
  display: flex;
  flex-direction: column;
`

export const StateDialogStyle = createGlobalStyle`
  .confirm-modal {
    @media (max-width: 520px) {
      div.ant-modal {
        width: calc(100% - 20px) !important;
        max-width: 100% !important;
      }
    }

    div.ant-modal-content {
      height: 100%;
      overflow: hidden;
      border-radius: 0;
    }

    div.ant-modal-body {
      height: 100%;
      padding: 24px 4px;
      overflow-y: auto;
      overflow-x: hidden;
    }

    div.ant-modal.confirm-modal {
      width: 502px !important;
    }

    div.ant-modal-confirm-body {
      & > span.anticon {
        display: none;
      }

      & .ant-modal-confirm-content {
        margin-top: 0;
      }
    }

    div.ant-modal-confirm-btns {
      display: none;
    }
  }
`
